

export const PartnerPricingdata = [
  {
    partner_firm_id: "1",
    PartnerCode: "10446",
    PartnerName: "Capital Den Advisory LLP",
    RecoveryMonthCurrent: "3",
    RecoveryMonthSet: "6",
    Date: "27/10/2021",
    flag: "Approved",
  },
  {
    partner_firm_id: "2",
    PartnerCode: "10646",
    PartnerName: "Blue Sky Education Pvt.",
    RecoveryMonthCurrent: "3",
    RecoveryMonthSet: "0",
    Date: "28/10/2021",
    flag: "Rejected",
  },
  {
    partner_firm_id: "3",
    PartnerCode: "10635",
    PartnerName: "AMBIKA CONSULTANCY",
    RecoveryMonthCurrent: "3",
    RecoveryMonthSet: "0",
    Date: "21/10/2021",
    flag: "Approved",
  },
  {
    partner_firm_id: "4",
    PartnerCode: "10638",
    PartnerName: "A H SOLUTIONS",
    RecoveryMonthCurrent: "3",
    RecoveryMonthSet: "6",
    Date: "27/12/2021",
    flag: "PendingForApproval",
  },
  {
    partner_firm_id: "5",
    PartnerCode: "10650",
    PartnerName: "Global Edu Connect",
    RecoveryMonthCurrent: "3",
    RecoveryMonthSet: "0",
    Date: "15/11/2021",
    flag: "PendingForApproval",
  },
  {
    partner_firm_id: "6",
    PartnerCode: "10655",
    PartnerName: "EduCare Consultants",
    RecoveryMonthCurrent: "3",
    RecoveryMonthSet: "0",
    Date: "10/12/2021",
    flag: "Approved",
  },
  {
    partner_firm_id: "7",
    PartnerCode: "10660",
    PartnerName: "Bright Future Advisors",
    RecoveryMonthCurrent: "3",
    RecoveryMonthSet: "0",
    Date: "05/01/2022",
    flag: "Query",
  },
  {
    partner_firm_id: "8",
    PartnerCode: "10665",
    PartnerName: "Scholar's Path",
    RecoveryMonthCurrent: "3",
    RecoveryMonthSet: "0",
    Date: "20/02/2022",
    flag: "Approved",
  },
  {
    partner_firm_id: "9",
    PartnerCode: "10670",
    PartnerName: "NextGen Education",
    RecoveryMonthCurrent: "3",
    RecoveryMonthSet: "0",
    Date: "12/03/2022",
    flag: "Query",
  },
  {
    partner_firm_id: "10",
    PartnerCode: "10675",
    PartnerName: "EduVision Partners",
    RecoveryMonthCurrent: "3",
    RecoveryMonthSet: "0",
    Date: "25/04/2022",
    flag: "Resolved",
  },
  {
    partner_firm_id: "11",
    PartnerCode: "10625",
    PartnerName: "VuVision Partners",
    RecoveryMonthCurrent: "3",
    RecoveryMonthSet: "0",
    Date: "25/05/2022",
    flag: "Resolved",
  },
];

// export const Partnerdata1= [

//     { partner_firm_id: '1', PartnerCode: '10446', PartnerName: 'Capital Den Advisory LLP', AgreementName:'Capital Den Advisory LLP', Date:'27/10/2021', Action:'edit' },
//     { partner_firm_id: '2', PartnerCode: '10646', PartnerName: 'Blue Sky Education Pvt.', AgreementName:'Blue Sky Education Pvt.', Date:'28/10/2021', Action:'edit' },
//     { partner_firm_id: '3', PartnerCode: '10635', PartnerName: 'AMBIKA CONSULTANCY', AgreementName:'AMBIKA CONSULTANCY', Date:'21/10/2021', Action:'edit' },
//     { partner_firm_id: '4', PartnerCode: '10638', PartnerName: 'A H SOLUTIONS', AgreementName:'A H SOLUTIONS', Date:'27/12/2021', Action:'edit' },
//     { partner_firm_id: '5', PartnerCode: "10650", PartnerName: "Global Edu Connect", AgreementName: "Global Edu Connect", Date: "15/11/2021", Action: "edit" },
//     { partner_firm_id: "6", PartnerCode: "10655", PartnerName: "EduCare Consultants", AgreementName: "EduCare Consultants", Date: "10/12/2021", Action: "edit" },
//     { partner_firm_id: "7", PartnerCode: "10660", PartnerName: "Bright Future Advisors", AgreementName: "Bright Future Advisors", Date: "05/01/2022", Action: "edit" },
//     { partner_firm_id: "8", PartnerCode: "10665", PartnerName: "Scholar's Path", AgreementName: "Scholar's Path", Date: "20/02/2022", Action: "edit" },
//     { partner_firm_id: "9", PartnerCode: "10670", PartnerName: "NextGen Education", AgreementName: "NextGen Education", Date: "12/03/2022", Action: "edit" },
//     { partner_firm_id: "10", PartnerCode: "10675", PartnerName: "EduVision Partners", AgreementName: "EduVision Partners", Date: "25/04/2022", Action: "edit" }

// ]
export const pricingData = [
  {
    partner_firm_id: 1,
    tranche: "Other",
    business: "EL",
    segment: "International",
    stream: "PG",
    country: "USA",
    price_type: "Fixed",
    start_slab: 0,
    end_slab: 0,
    percentage: 1,
    fy: 2025,
    effectiveDate: "01/02/2025",
    retrospective: "No",
  },
  {
    partner_firm_id: 2,
    tranche: "Other",
    business: "EL",
    segment: "International",
    stream: "PG",
    country: "USA",
    price_type: "slab",
    start_slab: 0,
    end_slab: 100000,
    percentage: 1,
    fy: 2025,
    retrospective: "No",
  },
  {
    partner_firm_id: 2,
    tranche: "Other",
    business: "EL",
    segment: "International",
    stream: "PG",
    country: "USA",
    price_type: "slab",
    start_slab: 100000,
    end_slab: 200000,
    percentage: 2,
    fy: 2025,
    retrospective: "No",
  },
];

export const data = [
  {
    success: true,
    message: "Request successful!",
    data: {
      tranche: [
        {
          catId: 6,
          catKey: "tranche",
          catValue: "All",
          catCode: "AL",
          active: 1,
        },
        {
          catId: 7,
          catKey: "tranche",
          catValue: "First",
          catCode: "FI",
          active: 1,
        },
        {
          catId: 8,
          catKey: "tranche",
          catValue: "Other",
          catCode: "OT",
          active: 1,
        },
      ],
      country: [
        {
          catId: 20,
          catKey: "country",
          catValue: "All",
          catCode: "AL",
          active: 1,
        },
        {
          catId: 21,
          catKey: "country",
          catValue: "Armenia",
          catCode: "AM",
          active: 1,
        },
        {
          catId: 22,
          catKey: "country",
          catValue: "Australia",
          catCode: "AU",
          active: 1,
        },
        {
          catId: 23,
          catKey: "country",
          catValue: "Belgium",
          catCode: "BE",
          active: 1,
        },
        {
          catId: 24,
          catKey: "country",
          catValue: "Canada",
          catCode: "CA",
          active: 1,
        },
        {
          catId: 25,
          catKey: "country",
          catValue: "Europe",
          catCode: "EU",
          active: 1,
        },
        {
          catId: 26,
          catKey: "country",
          catValue: "France",
          catCode: "FR",
          active: 1,
        },
        {
          catId: 27,
          catKey: "country",
          catValue: "Germany",
          catCode: "DE",
          active: 1,
        },
        {
          catId: 28,
          catKey: "country",
          catValue: "Hungary",
          catCode: "HU",
          active: 1,
        },
        {
          catId: 29,
          catKey: "country",
          catValue: "India",
          catCode: "IN",
          active: 1,
        },
        {
          catId: 30,
          catKey: "country",
          catValue: "Ireland",
          catCode: "IE",
          active: 1,
        },
        {
          catId: 31,
          catKey: "country",
          catValue: "Italy",
          catCode: "IT",
          active: 1,
        },
        {
          catId: 32,
          catKey: "country",
          catValue: "Lithuania",
          catCode: "LT",
          active: 1,
        },
        {
          catId: 33,
          catKey: "country",
          catValue: "Netherlands",
          catCode: "NL",
          active: 1,
        },
        {
          catId: 34,
          catKey: "country",
          catValue: "New Zealand",
          catCode: "NZ",
          active: 1,
        },
        {
          catId: 35,
          catKey: "country",
          catValue: "Poland",
          catCode: "PL",
          active: 1,
        },
        {
          catId: 36,
          catKey: "country",
          catValue: "Russia",
          catCode: "RU",
          active: 1,
        },
        {
          catId: 37,
          catKey: "country",
          catValue: "Singapore",
          catCode: "SG",
          active: 1,
        },
        {
          catId: 38,
          catKey: "country",
          catValue: "Sweden",
          catCode: "SE",
          active: 1,
        },
        {
          catId: 39,
          catKey: "country",
          catValue: "Switzerland",
          catCode: "CH",
          active: 1,
        },
        {
          catId: 40,
          catKey: "country",
          catValue: "United Kingdom",
          catCode: "UK",
          active: 1,
        },
        {
          catId: 41,
          catKey: "country",
          catValue: "United States of America",
          catCode: "US",
          active: 1,
        },
        {
          catId: 42,
          catKey: "country",
          catValue: "Other Countries",
          catCode: "OC",
          active: 1,
        },
      ],
      business: [
        {
          catId: 9,
          catKey: "business",
          catValue: "All",
          catCode: "AL",
          active: 1,
        },
        {
          catId: 10,
          catKey: "business",
          catValue: "EL",
          catCode: "EL",
          active: 1,
        },
        {
          catId: 11,
          catKey: "business",
          catValue: "EIL",
          catCode: "EI",
          active: 1,
        },
      ],
      stream: [
        {
          catId: 15,
          catKey: "stream",
          catValue: "All",
          catCode: "AL",
          active: 1,
        },
        {
          catId: 16,
          catKey: "stream",
          catValue: "UG",
          catCode: "UG",
          active: 1,
        },
        {
          catId: 17,
          catKey: "stream",
          catValue: "PG",
          catCode: "PG",
          active: 1,
        },
      ],
      segment: [
        {
          catId: 12,
          catKey: "segment",
          catValue: "All",
          catCode: "AL",
          active: 1,
        },
        {
          catId: 13,
          catKey: "segment",
          catValue: "International",
          catCode: "IN",
          active: 1,
        },
        {
          catId: 14,
          catKey: "segment",
          catValue: "Domestic",
          catCode: "DO",
          active: 1,
        },
      ],
      price_type: [
        {
          catId: 18,
          catKey: "price_type",
          catValue: "Fixed",
          catCode: "FX",
          active: 1,
        },
        {
          catId: 19,
          catKey: "price_type",
          catValue: "Slab",
          catCode: "SL",
          active: 1,
        },
      ],
      approval_stage: [
        {
          catId: 1,
          catKey: "approval_stage",
          catValue: "Pending for Approval",
          catCode: "PA",
          active: 1,
        },
        {
          catId: 2,
          catKey: "approval_stage",
          catValue: "Query",
          catCode: "QU",
          active: 1,
        },
        {
          catId: 3,
          catKey: "approval_stage",
          catValue: "Resolved",
          catCode: "RE",
          active: 1,
        },
        {
          catId: 4,
          catKey: "approval_stage",
          catValue: "Approved",
          catCode: "AP",
          active: 1,
        },
        {
          catId: 5,
          catKey: "approval_stage",
          catValue: "Rejected",
          catCode: "RJ",
          active: 1,
        },
      ],
    },
  },
];

// [{
//   approvalStageId: 1,
//   businessId: 1,
//   countryId: 1,
//   effectiveDate: "2025-02-28",
//   endSlab: "2",
//   partnerId: 46,
//   percentage: "1",
//   priceTypeId: 2,
//   pricingCode: "FT-EL-I-UG-SL-AU",
//   retrospective: "Yes",
//   segmentId: 1,
//   startSlab: "1",
//   streamId: 1,
//   tracId: "887a732b-de3c-4fe9-9bca-1f6d2a501930",
//   trancheId: 1,
// },

// {
//   approvalStageId: 1,
//   businessId: 1,
//   countryId: 1,
//   effectiveDate: "2025-02-28",
//   endSlab: "2",
//   partnerId: 46,
//   percentage: "1",
//   priceTypeId: 2,
//   pricingCode: "FT-EL-I-UG-SL-AU",
//   retrospective: "Yes",
//   segmentId: 1,
//   startSlab: "1",
//   streamId: 1,
//   tracId: "887a732b-de3c-4fe9-9bca-1f6d2a501930",
//   trancheId: 1,
// }
// ]


export const data1=[{
    "disbursement": [1],
    "partnerCode": 56,
    "Business": 1,
    "Segment": 2,
    "Stream": 2,
    "Pricing": 2,
    "pricingCode": "FT-EL-D-PG-SL-OT",
    "country": 7,
    "EffDate": "2025-05-12",
    "retrospective": "No",
    "ApprovalStage": 2,
    "pricingDetails": [
        {
            "MinimumSlab": 2000.01,
            "MaximumSlab": 0,
            "Percentage": 3,
            "pricingId": 451
        },
        {
            "MinimumSlab": 0,
            "MaximumSlab": 1000.99,
            "Percentage": 1,
            "pricingId": 454
        },
        {
            "MinimumSlab": 1001,
            "MaximumSlab": 2000,
            "Percentage": 2,
            "pricingId": 457
        }
    ],
    "allPricingRemarks": [
        {
            "pricingRemarkId": 857,
            "pricingId": 451,
            "remarks": "change slabe1 percentage to 0.8",
            "approvalStageId": 2,
            "userRole": "PAYOUT_CHECKER",
            "createdBy": "suhas s",
            "createdDate": "2025-05-12 15:41:03"
        },
        {
            "pricingRemarkId": 858,
            "pricingId": 454,
            "remarks": "change slabe1 percentage to 0.8",
            "approvalStageId": 2,
            "userRole": "PAYOUT_CHECKER",
            "createdBy": "suhas s",
            "createdDate": "2025-05-12 15:41:03"
        },
        {
            "pricingRemarkId": 859,
            "pricingId": 457,
            "remarks": "change slabe1 percentage to 0.8",
            "approvalStageId": 2,
            "userRole": "PAYOUT_CHECKER",
            "createdBy": "suhas s",
            "createdDate": "2025-05-12 15:41:03"
        },
        {
            "pricingRemarkId": 833,
            "pricingId": 451,
            "remarks": "initial pricing",
            "approvalStageId": 1,
            "userRole": "PAYOUT_MAKER",
            "createdBy": "prabhat b",
            "createdDate": "2025-05-12 15:37:50"
        },
        {
            "pricingRemarkId": 835,
            "pricingId": 454,
            "remarks": "initial pricing",
            "approvalStageId": 1,
            "userRole": "PAYOUT_MAKER",
            "createdBy": "prabhat b",
            "createdDate": "2025-05-12 15:37:50"
        },
        {
            "pricingRemarkId": 839,
            "pricingId": 457,
            "remarks": "initial pricing",
            "approvalStageId": 1,
            "userRole": "PAYOUT_MAKER",
            "createdBy": "prabhat b",
            "createdDate": "2025-05-12 15:37:50"
        }
    ]
}]